import { render } from "./RelatedProducts.vue?vue&type=template&id=e4596de4"
import script from "./RelatedProducts.vue?vue&type=script&lang=js"
export * from "./RelatedProducts.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Development\\git\\Giant-GIT\\Giant.B2C\\Giant.Website\\vue-apps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__